import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { companiesAPI } from '../../services/api';
import { FiSearch, FiMapPin, FiUsers, FiBriefcase, FiStar } from 'react-icons/fi';
import { truncate } from '../../utils/helpers';
import './Companies.css';

const CompaniesList = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await companiesAPI.list();
        const d = data.data || data.companies || data.results || (Array.isArray(data) ? data : []);
        setCompanies(d);
      } catch (e) {
        setCompanies(placeholders);
      }
      setLoading(false);
    };
    load();
  }, []);

  const filtered = companies.filter(c =>
    (c.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (c.industry || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="companies-page">
      <div className="container">
        <div className="page-header">
          <h1>Companies</h1>
          <p>Explore employers hiring across South Africa</p>
        </div>

        <div className="search-bar" style={{ marginBottom: '1.5rem' }}>
          <FiSearch className="icon" />
          <input type="text" placeholder="Search by company name or industry..." value={search}
            onChange={(e) => setSearch(e.target.value)} />
        </div>

        {loading ? (
          <div className="loading-container"><div className="spinner" /></div>
        ) : filtered.length > 0 ? (
          <div className="companies-grid">
            {filtered.map((c, i) => (
              <Link to={`/companies/${c.id}`} className="company-card" key={c.id || i}>
                <div className="company-logo">{(c.name || 'C')[0]}</div>
                <h3>{c.name}</h3>
                <div className="company-industry">{c.industry || 'Various'}</div>
                <p>{truncate(c.description || 'A company based in South Africa.', 120)}</p>
                <div className="company-meta">
                  {c.location && <span><FiMapPin /> {c.location}</span>}
                  {c.size && <span><FiUsers /> {c.size}</span>}
                  {c.jobs_count != null && <span><FiBriefcase /> {c.jobs_count} jobs</span>}
                  {c.rating && <span><FiStar /> {c.rating}</span>}
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="icon">🏢</div>
            <h3>No companies found</h3>
          </div>
        )}
      </div>
    </div>
  );
};

const placeholders = [
  { id: 1, name: 'TechCorp SA', industry: 'Technology', location: 'Johannesburg', size: '201-500', jobs_count: 12, description: 'Leading fintech company building digital solutions for emerging markets across Africa.' },
  { id: 2, name: 'FinServe Group', industry: 'Financial Services', location: 'Sandton', size: '501+', jobs_count: 8, description: 'Full-service financial institution offering banking, insurance, and investment products.' },
  { id: 3, name: 'BuildRight Construction', industry: 'Construction', location: 'Pretoria', size: '51-200', jobs_count: 5, description: 'Award-winning construction firm specializing in commercial and residential projects.' },
  { id: 4, name: 'GreenEnergy SA', industry: 'Energy', location: 'Cape Town', size: '51-200', jobs_count: 7, description: 'Renewable energy company at the forefront of South Africa\'s green energy transition.' },
  { id: 5, name: 'MedCare Holdings', industry: 'Healthcare', location: 'Durban', size: '201-500', jobs_count: 15, description: 'Healthcare group operating hospitals and clinics with a focus on accessible care.' },
  { id: 6, name: 'CloudFirst', industry: 'Technology', location: 'Remote', size: '11-50', jobs_count: 4, description: 'Cloud-native consultancy helping businesses migrate to modern infrastructure.' },
];

export default CompaniesList;
